import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { SVG_COMPONENTS } from '@/assets/admin';

interface SelectionIndicatorProps {
  selected?: boolean;
  size?: number;
  borderWidth?: number;
  color?: string; // border color when unselected
  selectedColor?: string; // fill/border when selected
  checkColor?: string;
  style?: ViewStyle;
}

export const SelectionIndicator: React.FC<SelectionIndicatorProps> = ({
  selected = false,
  size = 16,
  borderWidth = 2,
  color = ADMIN_COLORS.BORDER,
  selectedColor = ADMIN_COLORS.PRIMARY,
  checkColor = '#FFFFFF',
  style,
}) => {
  const dimensionStyle = {
    width: size,
    height: size,
    borderRadius: size / 2,
    borderWidth,
    borderColor: selected ? selectedColor : color,
    backgroundColor: selected ? selectedColor : 'transparent',
  } as ViewStyle;

  const checkSize = Math.max(8, Math.round(size * 0.6));

  return (
    <View style={[styles.container, dimensionStyle, style]}>
      {selected && (
        <SVG_COMPONENTS.CHECK_CIRCLE width={checkSize} height={checkSize} color={checkColor} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});


